import React from "react"

import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./illustration.module.scss"

const Illustration = ({ icon, className, size }) =>
  icon ? (
    <Image
      {...icon}
      className={`${styles.iconWrapper}  ${className} ${
        styles[`iconWrapper__${size}`]
      }`}
      width={80}
      imgClassName={`${styles.icon} ${styles[`icon__${size}`]}`}
      alt=""
    />
  ) : (
    ""
  )

export default Illustration

Illustration.propTypes = {
  icon: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
}

Illustration.defaultProps = {
  icon: "",
  className: "",
  size: "s",
}
